import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import { withRouter } from 'react-router-dom';

let region = localStorage.getItem("zennerOrSensus");

const SubMenu = observer(({ layer, activeLayer, label, color, data, point, setLayer, removeLayer, closeMenu }) => {
	if(layer == "smart" && region == "Sensus"){
		data = data.filter((o) => {
			return(
			[o[layer] == 1,
			o.sensus != 0].every(x => x))
		});
	}
	if(layer == "smart" && region == "Sensus"){
		data = data.filter((o) => {
			return(
			[o[layer] == 1,
			o.zenner != 0].every(x => x))
		});
	}
	return (
		<li>
			<Link
				to={`/${activeLayer == layer ? '' : layer}`}
				style={{ color }}
				onClick={() => {
					if (activeLayer == layer) {
						removeLayer();
						// ga('send', 'event', 'LB City', label, 'Menu Layer Collapsed');
						dataLayer.push({
						  'event': 'gaEvent',
						  'eventCategory': 'LB City - ' + layer,
						  'eventAction': 'Menu Layer Collapsed',
						  'eventLabel': label
						});
					} else {
						setLayer(layer);
						// ga('send', 'event', 'LB City', label, 'Menu Layer Expanded');
						dataLayer.push({
							'event': 'gaEvent',
							'eventCategory': 'LB City - ' + layer,
							'eventAction': 'Menu Layer Expanded',
							'eventLabel': label
						  });
					}
				}}
			>
				<i className={activeLayer == layer ? 'far fa-minus-circle' : 'far fa-plus-circle'} />
				{label}
			</Link>
			<ul className={activeLayer == layer ? 'opened' : 'closed'}>
				{data.filter((o) => o[layer] == 1 ).sort((a, b) => a.sort - b.sort).map((o, i) => (
					<li key={o.id} className={point == o.id ? 'active' : ''}>
						<Link
							to={`/${layer}/${o.id}`}
							onClick={() => {
								// ga('send', 'event', 'LB City', label, 'Menu Zoom To POI');
								dataLayer.push({
									'event': 'gaEvent',
									'eventCategory': 'LB City - ' + layer,
									'eventAction': 'Menu Zoom To POI',
									'eventLabel': label
								});
								if (window.innerWidth <= 992) {
									closeMenu();
								}
							}}
						>
							{o.label}
						</Link>
					</li>
				))}
			</ul>
		</li>
	);
});
@inject('store')
@observer
class Menu extends Component {
	@observable menuOpen = true;

	componentDidMount() {
		//!! FOR DEVELOPMENT ONLY
		if (location.hostname == 'localhost' || location.hostname.includes('192.168')) {
			this.menuOpen = false;
		}
	}

	// when props change (ex, popup from router)
	// handle those actions here
	// componentWillReceiveProps() {
	//     this.menuOpen = this.props.show
	// }

	getMenuHeight() {
		return `${window.innerHeight - 140}px`;
	}

	render() {
		return (
			<div id="menu" className={this.menuOpen ? 'opened' : 'closed'}>
				<div
					className="menu-toggle"
					onClick={() => {
						this.menuOpen = !this.menuOpen;
						$('body').toggleClass('menu-opened');
						// ga('send', 'event', 'LB City', `Menu ${this.menuOpen ? 'Opened' : 'Closed'}`);
						dataLayer.push({
							'event': 'gaEvent',
							'eventCategory': 'LB City - ' + this.props.store.layer,
							'eventLabel': `Menu ${this.menuOpen ? 'Opened' : 'Closed'}`
						});
					}}
				>
					<i className={`far fa-chevron-double-${this.menuOpen ? 'left' : 'right'}`} />
					<span>{this.menuOpen ? 'CLOSE' : 'MENU'}</span>
				</div>
				<div className="menu-logo" onClick={() => this.props.onLogoClick()}>
					<Link to="/">
						<img src="/city/assets/logo-white.png" alt="" />
					</Link>
				</div>
				<ul className="menu-base" style={{ height: this.getMenuHeight() }}>
					<p>
						Welcome to LB City! We invite you to explore the interactive map to learn more about waterworks industry systems and their
						component products.
					</p>
					{region == "Sensus" && (
						<SubMenu
							layer="sensus"
							label="Potable Water"
							color="#1646ab"
							activeLayer={this.props.store.layer}
							data={this.props.store.points}
							point={this.props.store.point}
							setLayer={(Layer) => this.props.store.setLayer(Layer)}
							removeLayer={() => this.props.store.removeLayer()}
							closeMenu={() => (this.menuOpen = false)}
						/>
					)}
					{region == "Zenner" && (
						<SubMenu
							layer="zenner"
							label="Potable Water"
							color="#1646ab"
							activeLayer={this.props.store.layer}
							data={this.props.store.points}
							point={this.props.store.point}
							setLayer={(Layer) => this.props.store.setLayer(Layer)}
							removeLayer={() => this.props.store.removeLayer()}
							closeMenu={() => (this.menuOpen = false)}
						/>
					)}
					<SubMenu
						layer="waste"
						label="Wastewater"
						color="#3ad532"
						activeLayer={this.props.store.layer}
						data={this.props.store.points}
						point={this.props.store.point}
						setLayer={(Layer) => this.props.store.setLayer(Layer)}
						removeLayer={() => this.props.store.removeLayer()}
						closeMenu={() => (this.menuOpen = false)}
					/>
					<SubMenu
						layer="storm"
						label="Stormwater"
						color="#83d6fe"
						activeLayer={this.props.store.layer}
						data={this.props.store.points}
						point={this.props.store.point}
						setLayer={(Layer) => this.props.store.setLayer(Layer)}
						removeLayer={() => this.props.store.removeLayer()}
						closeMenu={() => (this.menuOpen = false)}
					/>
					<SubMenu
						layer="smart"
						label="Smart Water"
						color="#f7941c"
						activeLayer={this.props.store.layer}
						data={this.props.store.points}
						point={this.props.store.point}
						setLayer={(Layer) => this.props.store.setLayer(Layer)}
						removeLayer={() => this.props.store.removeLayer()}
						closeMenu={() => (this.menuOpen = false)}
					/>
				</ul>
			</div>
		);
	}
}

export default withRouter(Menu);
